$(document).on('change', '[data-search-table]', window.Foundation.util.debounce(function _() {
  const $this = $(this);
  const $table = $(`[data-table="${$this.attr('data-search-table')}"]`);
  const $thead = $table.find('thead');
  const $tbody = $table.find('> tbody');
  const $noEntry = $table.find('[data-table-noentry]');
  const $onInput = $table.find('[data-table-oninput]');
  const $searchQuery = $table.find('[data-table-search-query]');
  const highlight = $table.is('[data-highlight]');
  const query = $this.val();
  const searchQuery = query.toLowerCase();

  // Show all rows if query empty
  if (query.length === 0) {
    $tbody
      .find('> tr:not([data-table-noentry],[data-table-oninput])').removeClass('hide')
      .find('> td').removeClass('highlight');
    $noEntry.addClass('hide');
    $onInput.addClass('hide');
    return;
  }

  // Find searchable columns
  const searchableColumns = [];
  $thead.find('th').each((colCounter, th) => {
    if ($(th).is('[data-searchable]')) {
      searchableColumns.push(colCounter);
    }
  });

  // Hide rows, which does not contain query
  $tbody.find('> tr:not([data-table-noentry],[data-table-oninput])').each((rowCounter, tr) => {
    const $tr = $(tr);
    let hit = false;

    $tr.find('> td').each((colCounter, td) => {
      if (searchableColumns.indexOf(colCounter) > -1) {
        const $td = $(td);
        const containsQuery = $td.text().toLowerCase().indexOf(searchQuery) > -1;

        if (containsQuery) {
          hit = true;
        }

        if (highlight) {
          $td.toggleClass('highlight', containsQuery);
        }
      }
    });

    $tr.toggleClass('hide', !hit);
  });


  if ($noEntry) {
    if ($tbody.find('> tr:not([data-table-noentry],[data-table-oninput]):not(.hide)').length === 0) {
      if ($searchQuery) {
        $searchQuery.text(query);
      }
      $noEntry.removeClass('hide');
    } else {
      $noEntry.addClass('hide');
    }
  }

  if ($onInput) {
    if ($searchQuery) {
      $searchQuery.text(query);
      $onInput.removeClass('hide');
    } else {
      $onInput.addClass('hide');
    }
  }
}, 150));

// Sortable table
$(document).on('click', '[data-sortable-table] [data-ordering]', function sort() {
  const $this = $(this);
  const $table = $this.closest('table');
  const url = $table.attr('data-sortable-table');

  if (url) {
    // backend sorting
    const ordering = $this.attr('data-ordering');
    const idx = url.indexOf('?');
    const host = idx >= 0 ? url.substr(0, idx) : url;
    const params = new URLSearchParams(idx >= 0 ? url.substr(idx) : '');
    params.set('ordering', ordering);
    document.location.replace(`${host}?${params.toString()}`);
  } else {
    // frontend sorting
    const datatype = $this.attr('data-datatype');
    const dir = this.classList.contains('ordered--asc') ? -1 : 1;
    const $tbody = $table.find('tbody').first();
    const index = $table.find('thead th').removeClass('ordered--asc').removeClass('ordered--desc').index($this);
    $this.addClass(dir === -1 ? 'ordered--desc' : 'ordered--asc');

    // sort the rows
    const rows = $tbody.find('tr').toArray().sort((a, b) => {
      let aValue = $(a).find('td').eq(index).attr('data-ordering-value');
      let bValue = $(b).find('td').eq(index).attr('data-ordering-value');
      if (aValue === undefined) {
        return 1;
      }
      if (bValue === undefined) {
        return -1;
      }
      if (datatype === 'number') {
        aValue = parseFloat(aValue);
        bValue = parseFloat(bValue);
      }
      if (aValue < bValue) {
        return -1 * dir;
      }
      if (aValue > bValue) {
        return dir;
      }
      return 0;
    });

    // append the rows in the new order
    $tbody.append(rows);
  }
});
